import React from 'react';
import MaterialButton, { ButtonProps } from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import classnames from 'classnames';
import Tooltip from '../Tooltip/Tooltip';

const useStyles = makeStyles(() => ({
  progress: {
    color: 'white'
  },
  progressBox: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  hide: {
    visibility: 'hidden'
  },
  small: {
    height: '1.375rem',
    padding: '0 0.5rem',
    borderRadius: '50px'
  },
  tooltipBox: {
    position: 'absolute',
    top: '-16px',
    right: '-1.5rem',
    color: '#000000de',
    pointerEvents: 'all'
  },
  btn: {
    height: '38px',
    borderRadius: '50px'
  },
  outlined: {
    color: '#0080BD !important',
    fontWeight: 700
  },
  text: {
    color: '#0080BD !important',
    padding: '0.5rem',
    fontWeight: 700
  },
  gray: {
    backgroundColor: '#949d9d',
    borderRadius: '50px'
  }
}));

interface ButtonPropsExtended extends ButtonProps {
  children: any;
  isLoading?: boolean;
  component?: string;
  endIcon?: any;
  startIcon?: any;
  small?: boolean;
  gray?: boolean;
  className?: any;
  tooltip?: any;
  id?: string;
}

const Button = ({
  children,
  isLoading,
  endIcon,
  startIcon,
  small,
  gray,
  className,
  tooltip,
  id,
  variant = 'contained',
  color = 'secondary',
  ...rest
}: ButtonPropsExtended) => {
  const classes = useStyles(rest);
  return (
    <MaterialButton
      {...rest}
      variant={variant}
      color={color}
      endIcon={endIcon ? endIcon : null}
      startIcon={startIcon ? startIcon : null}
      style={{
        border: className === 'outlined' ? '2px solid' : '',
        ...rest.style
      }}
      className={classnames(
        className ? className : classes.btn,
        small && classes.small,
        gray && classes.gray
      )}
      id={id}
    >
      {isLoading && (
        <span className={classes.progressBox}>
          <CircularProgress
            className={classes.progress}
            size={small ? 12 : 24}
          />
        </span>
      )}
      <span
        className={classnames(
          isLoading ? classes.hide : undefined,
          className === 'outlined' && classes.outlined,
          className === 'text' && classes.text
        )}
      >
        {children}
      </span>
      {tooltip && (
        <span className={classes.tooltipBox}>
          <Tooltip text={tooltip} />
        </span>
      )}
    </MaterialButton>
  );
};

export default Button;
